export default function WhatsSP() {
  return <section className="home-about-heading"><div className="home-container"><h2>What is Social Paws?</h2></div></section>;
}
